//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import veeValidate from '~/mixins/veeValidate'
import { Breadcrumbs } from '~/plugins/breadcrumbs'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import VueToastMixin from '~/mixins/plugins/vue-toastification'
import SearchBarForm from '~/components/form/search-bar-form.vue'
import { CACHE_SETTINGS } from '~/utils/cache'
import { getLocations, getReviews } from '~/utils/server'

import OffersInMailbox from '~/components/section/offers-in-mailbox.vue'
import { capitalizeFirstLetter, dcopy } from '~/utils/utils'
import SearchModal from '~/components/modal/search/search-modal.vue'
import AdminSections from '~/components/admin-sections/admin-sections.vue'
import SeoSailingHolidays from '~/components/seo/sailing-holidays.vue'
import FaqItems from '~/components/Flotillas/FaqItems.vue'
import RequestAction from '~/components/global/RequestAction.vue'
import adminSectionPage from '~/mixins/admin-section-page'
import urlTranslator from '~/middleware/url-translator'
import AdminSectionGallery from '~/components/admin-sections/section-gallery.vue'
import OtherLocations from '~/components/seo/other-locations.vue'
import SearchComponent from '~/components/search/page/search-component.vue'
import PageTop from '~/components/section/page-top.vue'
import searchUtils from "~/mixins/search/search-utils";

export default {
  name: 'BoatRental',
  components: {
    PageTop,
    SearchComponent,
    OtherLocations,
    AdminSectionGallery,
    RequestAction,
    FaqItems,
    SeoSailingHolidays,
    AdminSections,
    SearchModal,
    OffersInMailbox,
    SearchBarForm
  },
  mixins: [veeValidate, VueToastMixin, adminSectionPage, searchUtils],
  middleware: [urlTranslator],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      const ietfLocale = ctx.store.getters['lang/currentLanguage']?.ietf_locale
      const lang = ctx.store.getters['lang/locale']
      const ietf = ietfLocale || 'en-gb'

      const [page, simpleLocation, reviews] = await Promise.all([
        ctx.$axios.get('/api/content-page?link=skippered-yacht-charter&lang=' + lang),
        ctx.$cacheFetch({
          key: `pIndex-getLocationsHome?locale=${lang}&limit=${23}`, expire: CACHE_SETTINGS.baseTime
        }, async () => {
          return await getLocations(ctx, {
            lang,
            ietf,
            locationType: [
              { id: 'region', key: 'region' },
              { id: 'country' },
              { id: 'city' },
              { id: 'marina' },
              { id: 'popular' }
            ],
            locationLimit: {
              default: 23,
              popular: 10
            }
          })
        }),

        ctx.$cacheFetch({
          key: `pIndex-getReviews-locale=${lang}`,
          expire: CACHE_SETTINGS.baseTime
        }, async () => {
          return await getReviews(ctx, lang)
        })
      ])

      if (Object.keys(page?.data || {}).length === 0) {
        ctx.redirect(302, ctx.app.router.resolve({ name: 'destinations' }).href)
        return
      }

      await ctx.store.dispatch('setBreadcrumbs', Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [
        {
          title: ctx.app.i18n.t('sailing-holidays'),
          url: ctx.app.router.resolve({ name: 'sailing-holidays' }).href
        },
        {
          title: page?.data?.data?.title,
          url: ctx.route.fullPath
        }
      ]))

      const moreLocations = [
        ...(simpleLocation.city || []).slice(0, 5),
        ...(simpleLocation.country || []).slice(0, 5),
        ...(simpleLocation.marina || []).slice(0, 5),
        ...(simpleLocation.popular || []).slice(0, 5),
        ...(simpleLocation.region || []).slice(0, 5)
      ].sort((a, b) => a.boat_count < b.boat_count)
      ctx.store.commit('SET_META_DATA', {
        title: page.data?.data.meta_title,
        meta: [
          { name: 'title', property: 'og:title', hid: 'title', content: page.data?.data.meta_title },
          { name: 'description', property: 'og:description', hid: 'description', content: page.data?.data.meta_description },
          { name: 'twitter:title', content: page.data?.data.meta_title },
          { name: 'author', content: 'Tubber' },
          { name: 'twitter:description', content: page.data?.data.meta_description }
        ],
        link: []
      })
      return {
        page: page.data,
        simpleLocation,
        reviews,
        moreLocations
      }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      showAllButton: {
        sliceResults: 3,
        text: ''
      }
    }
  },
  head () {
    return {
      title: this.page?.data.meta_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          property: 'og:description',
          content: this.page?.data.meta_description
        }
      ]
    }
  },
  computed: {
    ...mapState({
      breakpoint: 'breakpoint',
      currentCurrency: state => state.lang.currentCurrency,
      loading: state => state.search.loading,
      location: state => state.search.locationFull,
      filters: state => state.search.filters,
      results: state => state.search.results
    }),
    ...mapGetters({
      currentCurrency: 'lang/currentCurrency',
      locale: 'lang/locale',
      userCredits: 'auth/userCredits',
      searchTerms: 'search/searchTerms'
    }),
    amountResultsFound () {
      return this.$options.filters.numberWithCommas(this.$store.state.search.amountResultsFound)
    },
    searchTerms: {
      get () {
        return dcopy(this.$store.getters['search/searchTerms'])
      },
      set (value) {
        this.$store.dispatch('search/changeSearchTerms', value)
      }
    },
    sortBy: {
      get () {
        return this.searchTerms.sortBy
      },
      set (value) {
        this.$store.dispatch('search/changeFilter', { key: 'sortBy', value })
        this.$store.dispatch('search/changeFilter', { key: 'page', value: null })
        if (this.$refs.filters) {
          this.$refs.filters.applyFilters()
        }
      }
    },
    boatTypes () {
      return this.$store.state.search.staticBoatTypes.map((t) => {
        return {
          ...t,
          name: t.translate ? capitalizeFirstLetter(this.$t(t.name.toLowerCase())) : t.name
        }
      })
    },
    getTopGallery () {
      return { ...(this.page.galleries?.[0] || {}), type: 'gallery' }
    },
    getPage () {
      const modifiedPage = dcopy(this.page)
      const featuredItems = []
      modifiedPage.sections = modifiedPage?.sections?.sort((a, b) => a.sort_order < b.sort_order)?.map((s) => {
        if (s?.sort_order === 3 && s.type === 'section-text') {
          s.images = modifiedPage?.galleries?.[1]?.images
          s.texts = [s]
          s.type = 'gallery-with-text'
        }

        if (s?.type === 'feature-item') {
          featuredItems.push(s)
          return false
        }

        return s
      }).map((s) => {
        if (s?.sort_order === 7) {
          s.type = 'feature-items'
          s.items = featuredItems.filter((f) => {
            return !f?.raw_json?.['admin-section']?.type
          }).sort((a, b) => a.sort_order - b.sort_order)
        }
        if (s?.sort_order === 6) {
          s.type = 'blog-items'
          s.items = (modifiedPage.blogs || [])
        }
        if (s?.sort_order === 5) {
          s.type = 'feature-items-with-number'
          s.items = featuredItems.filter((f) => {
            return f?.raw_json?.['admin-section']?.type === 'with-numbers'
          }).sort((a, b) => a.sort_order - b.sort_order)
        }
        return s
      }).filter(Boolean)

      modifiedPage.galleries = []

      modifiedPage.sections = modifiedPage.sections.sort((a, b) => a.sort_order - b.sort_order)

      return modifiedPage
    },
    getShowAllButton () {
      return {
        sliceCount: 3,
        text: this.$t('show-all') + ' ' + (this.amountResultsFound) + ' ' + this.$tc(`${this.$t('boat')} | ${this.$t('boats_low')}`, this.amountResultsFound),
        hrefLink: this.$Search.generateClientUrl()
      }
    }
  },
  mounted () {
    this.createdMethod()
    this.$scrollTo({ y: 0 })
  },
  methods: {
    createdMethod () {
      this.$Search.setAttributeValue('location', 'croatia')
      this.$Search.setAttributeValue('limit_date', false)

      this.$Search.setAttributeValue('sortBy', '-premium_boat')
      this.$Search.search({ changeUrl: false })
    },
    searchFilterFiltersFunction (filters) {
      if (filters.boat_types && Array.isArray(filters.boat_types)) {
        filters.boat_types = filters.boat_types.filter((i) => {
          return ![50, 99, 49].includes(parseInt(i.key, 10))
        })
      }
      return filters
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$Search.resetAllAttributes()
    next()
  }
}
